/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_SaveInputs */

const en_byoa_save = /** @type {(inputs: Byoa_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save connection`)
};

const id_byoa_save = /** @type {(inputs: Byoa_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan koneksi`)
};

/**
* | output |
* | --- |
* | "Save connection" |
*
* @param {Byoa_SaveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_save = /** @type {((inputs?: Byoa_SaveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_SaveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_save(inputs)
	return en_byoa_save(inputs)
});